import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractFormDialogComponent, FormDialogData } from '@gipi-pages/abstract/abstract-form-dialog.component';
import { TypeVersionModel } from '@gipi-pages/type-version/models/type-version.model';
import { TypeVersionService } from '@gipi-pages/type-version/services/type-version.service';
import { AlertService } from '@gipi-ui/services/alert.service';
import { ObjectUtil } from '@gipi-ui/utils/object.util';
import { StringUtil } from '@gipi-ui/utils/string.util';

@Component({
    selector: 'gipi-type-version-form-dialog',
    templateUrl: './type-version-form-dialog.component.html',
    styleUrls: ['./type-version-form-dialog.component.scss']
})
export class TypeVersionFormDialogComponent extends AbstractFormDialogComponent<TypeVersionModel> implements OnInit {

    constructor(
        protected service: TypeVersionService,
        protected dialogRef: MatDialogRef<TypeVersionFormDialogComponent>,
        private _alertService: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: FormDialogData<TypeVersionModel> = { typeOperation: 'NEW', entity: null },
    ) {
        super(service, dialogRef, data);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    protected newEntity(): TypeVersionModel {
        return new TypeVersionModel();
    }

    protected isValid(): boolean {
        if (ObjectUtil.isNull(this.entity)) {
            return false;
        }
        if (!this.entity.description) {
            this._alertService.addWarningMessage('Campo descrição é obrigatório e não foi informado');
            return false;
        }
        if (StringUtil.isEmpty(this.entity.initials)) {
            this._alertService.addWarningMessage('Campo iniciais é obrigatório e não foi informado');
            return false;
        }
        if (this.entity.initials.length !== 3) {
            this._alertService.addWarningMessage('Campo iniciais deve conter exatamente 3 caracteres');
            return false;
        }

        return true;
    }

    public confirm(): void {
        try {
            if (!this.isValid()) {
                return;
            }

            this.loading = true;

            this.service.save(this.entity).toPromise().then(() => {
                this._alertService.addSuccessMessage('Operação realizada com sucesso');
                this.loading = false;
                this.close('RELOAD_TABLE');
            }, error => {
                throw new Error(error);
            });
        } catch (e) {
            this.loading = false;
            this._alertService.handleError(e);
        }
    }

}
